import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from '../API/ApiUrl';

const UpcomeMassTime = () => {
    const [upcomingMass, setUpcomingMass] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMassTimings = async () => {
            try {
                const response = await axios.get(`${ApiUrl}/get/masstime`);
                if (response.data.success && response.data.data.length > 0) {
                    const now = new Date();
                    const timings = response.data.data;

                    // Filter for future timings and sort by date
                    const futureTimings = timings
                        .map(t => ({ ...t, dateObj: new Date(t.startdate) }))
                        .filter(t => t.dateObj > now)
                        .sort((a, b) => a.dateObj - b.dateObj);

                    if (futureTimings.length > 0) {
                        const nextMass = futureTimings[0];
                        const date = nextMass.dateObj;

                        // Check if it's today
                        const isToday = date.toDateString() === now.toDateString();
                        let dayStr = '';

                        if (isToday) {
                            dayStr = 'Today';
                        } else {
                            // Format day name safely
                            try {
                                dayStr = date.toLocaleDateString('en-US', { weekday: 'long' });
                            } catch (e) {
                                // Fallback if toLocaleDateString fails
                                const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                                dayStr = days[date.getDay()];
                            }
                        }

                        // Format time manually for better compatibility
                        const hours = date.getHours();
                        const minutes = date.getMinutes();
                        const ampm = hours >= 12 ? 'PM' : 'AM';
                        const displayHours = hours % 12 || 12;
                        const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
                        const timeStr = `${displayHours}:${displayMinutes} ${ampm}`;

                        setUpcomingMass(`${dayStr} at ${timeStr}`);
                    } else {
                        setUpcomingMass('No upcoming mass scheduled.');
                    }
                } else {
                    setUpcomingMass('No mass timings found.');
                }
            } catch (error) {
                console.error('Error fetching mass timings:', error);
                setUpcomingMass('Error loading timing.');
            } finally {
                setLoading(false);
            }
        };

        fetchMassTimings();
    }, []);

    return (
        <div>
            {loading ? (
                <p>Loading...</p>
            ) : upcomingMass ? (
                <h6 className="home-mass-date">Upcoming Mass Time: {upcomingMass}</h6>
            ) : null}
        </div>
    );
};

export default UpcomeMassTime;